const items = {
  "forms.fields.email.label": "email",
  "forms.fields.email.or.username.label": "email / username",
  "forms.fields.password.label": "password",
  "forms.fields.confirm-password.label": "confirm password",
  "forms.fields.id.label": "ID",
  "forms.fields.message.label": "message",
  "forms.fields.created-at.label": "created at",
  "forms.fields.updated-at.label": "updated at",
  "forms.fields.lang.label": "language",
  "forms.message.lang.required": "language is required",
  "forms.fields.title.label": "title",
  "forms.message.title.required": "title is required",
  "forms.fields.subtitle.label": "subtitle",
  "forms.fields.summary.label": "summary",
  "forms.fields.content.label": "content",
  "forms.fields.content.placeholder": "content",
  "forms.fields.tag.label": "tag",
  "forms.fields.power.label": "power",
  "forms.fields.type.label": "type",
  "forms.fields.publicity.label": "publicity",
  "forms.fields.publicity.all.label": "all",
  "forms.fields.publicity.disable.label": "disable",
  "forms.fields.publicity.blocked.label": "blocked",
  "forms.fields.publicity.private.label": "private",
  "forms.fields.publicity.public_no_list.label": "public no list",
  "forms.fields.publicity.public.label": "public",
  "forms.fields.publicity.public.edit.label": "public edit",
  "forms.fields.teacher.label": "teacher",
  "forms.fields.studentsassistant.label": "students / assistant",
  "forms.fields.student.label": "student",
  "forms.fields.assistant.label": "assistant",
  "forms.fields.lesson.label": "lesson",
  "forms.fields.note.label": "note",
  "forms.fields.confidence.label": "confidence",
  "forms.fields.confidence.0.label": "0",
  "forms.fields.confidence.25.label": "25",
  "forms.fields.confidence.50.label": "50",
  "forms.fields.confidence.75.label": "75",
  "forms.fields.confidence.100.label": "100",
  "forms.fields.upload.texture": "upload cover",
  "forms.fields.markdown.label": "markdown preview",
  "forms.fields.role.label": "role",
  "forms.fields.name.label": "name",
  "forms.fields.meaning.label": "meaning",
  "forms.fields.meaning.tooltip": "up to 256 chars",
  "forms.message.meaning.required": "meaning is required",
  "forms.fields.factors.label": "factors",
  "forms.fields.factors.tooltip": "up to 256 chars",
  "forms.fields.factor.meaning.label": "factor meaning",
  "forms.fields.factor.meaning.tooltip": "up to 256 chars",
  "forms.fields.parent.label": "parent",
  "forms.fields.parent.tooltip": "up to 256 chars",
  "forms.fields.case.label": "grammar",
  "forms.fields.case.tooltip": "语法信息参见……",
  "forms.fields.user.label": "user",
  "forms.message.user.required": "user is required",
  "forms.message.user.delete": "删除用户吗？此操作无法恢复。",
  "forms.message.member.remove": "移除此成员吗？此操作无法恢复。",
  "forms.fields.description.label": "description",
  "forms.fields.textbook.label": "textbook",
  "forms.fields.status.label": "status",
  "forms.fields.ending.label": "ending",
  "forms.fields.relation.label": "relation",
  "forms.fields.from.label": "from",
  "forms.fields.to.label": "to",
  "forms.fields.count.label": "count",
  "forms.fields.owner.label": "owner",
  "forms.message.res.remove": "将此此资源从群中移除吗？",
  "forms.fields.parent2.label": "parent of derivative",
  "forms.fields.parent2.tooltip": "up to 256 chars",
  "forms.fields.username.label": "username",
  "forms.fields.nickname.label": "nickname",
  "forms.fields.editor.label": "editor",
  "forms.fields.category.label": "category",
  "forms.fields.match.label": "match",
  "forms.fields.dict.name.label": "name",
  "forms.fields.dict.shortname.label": "shortname",
  "forms.fields.url.label": "url",
  "forms.fields.fail.label": "fail",
  "forms.fields.success.label": "success",
  "forms.fields.receiver.label": "receiver",
  "forms.fields.event.label": "event",
  "forms.message.question.required": "question is required",
  "forms.message.question.description.option": "description(option)",
  "forms.fields.replay.label": "replay",
  "forms.status.transferred.label": "transferred",
  "forms.status.accept.label": "accepted",
  "forms.status.refuse.label": "refused",
  "forms.status.cancel.label": "canceled",
  "forms.fields.sign-up-message.label": "sign up message",
  "forms.fields.color.label": "color",
  "forms.fields.executors.label": "executors",
  "forms.fields.executor.label": "executor",
  "forms.fields.milestone.label": "milestones",
  "forms.fields.started-at.label": "started at",
  "forms.fields.finished-at.label": "finished at",
  "forms.fields.assignees.label": "assignees",
  "forms.fields.model.label": "model",
  "forms.fields.key.label": "key",
};

export default items;
